import styled from "styled-components";

// ===================================
// CARD CONTAINER
// ===================================
export const CardContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: 100%;
  background: white;
  border-top-left-radius: 35px;
  border-top-right-radius: 35px;
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    box-shadow: none;
  }
`;

// ===================================
// HEADER - Campaña
// ===================================
export const CardHeader = styled.div.attrs({
  className: "payment-card-header"
})`
  padding: 24px;
  background: #0bbef0;
  border-top-left-radius: 35px;
  border-top-right-radius: 35px;
  display: flex;
  justify-content: left;
  align-items: center;
  min-height: 100px;

  @media (max-width: 1024px) {
    min-height: auto;
    padding: 20px 16px;
  }
`;

export const CampaignName = styled.div`
  color: white;
  font-size: 20px;
  font-family: Nunito, sans-serif;
  line-height: 24px;
  word-wrap: break-word;
  text-align: left;

  span.regular {
    font-weight: 400;
  }

  span.bold {
    font-weight: 700;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

// ===================================
// STATUS BADGE - Estado del pago
// ===================================
export const StatusBadge = styled.div`
  padding: 8px 24px;
  background: ${(props) =>
    props.isOverdue ? "rgba(255, 189, 202, 0.45)" : "rgba(11, 190, 240, 0.15)"};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusIcon = styled.div`
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: ${(props) =>
    props.isOverdue
      ? "url(/assets/images/info-tooltip.png)"
      : "url(/assets/images/info-tooltip-normal.png)"};
`;

export const WarningIcon = styled.div`
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: contain;

  background-image: ${(props) =>
    props.isPartialOverdue
      ? "url(/assets/images/alert.png)"
      : "url(/assets/images/alert-normal.png)"};

  @media (max-width: 768px) {
    width: 22px;
    height: 22px;
  }
`;

export const StatusText = styled.div`
  color: ${(props) => (props.isOverdue ? "#FF317B" : "#0BBEF0")};
  font-size: 14px;
  font-family: Nunito, sans-serif;
  line-height: 20px;

  span.regular {
    font-weight: 400;
  }

  span.bold {
    font-weight: 700;
  }
`;

// ===================================
// TRANSACTION STATUS BADGE - Estado de transacción HU AC03
// ===================================
/**
 * Badge con colores según estado:
 * - pending: amarillo (En proceso)
 * - rejected: rojo (Rechazada)
 * - approved: verde (Pago aprobado)
 * - info: azul (Mensaje informativo)
 */
export const TransactionStatusBadge = styled.div`
  padding: 8px 24px;
  display: flex;
  align-items: center;
  gap: 8px;

  ${(props) => {
    if (props.status === "pending") {
      return `
        background: #FEF5C2;
      `;
    }

    if (props.status === "rejected") {
      return `
        background: #FFC2D8;
      `;
    }

    if (props.status === "approved") {
      return `
        background: #E8F7F1;
      `;
    }

    if (props.status === "info") {
      return `
        background: #E0F4F9;
      `;
    }

    return `
      background: #FEF5C2;
    `;
  }}
`;

export const TransactionStatusIcon = styled.div`
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: contain;

  ${(props) => {
    if (props.status === "pending") {
      return `
        background-image: url(/assets/images/info-tooltip-normal.png);
      `;
    }

    if (props.status === "rejected") {
      return `
        background-image: url(/assets/images/info-tooltip-normal.png);
      `;
    }

    if (props.status === "approved") {
      return `
        background-image: url(/assets/images/info-tooltip-normal.png);
      `;
    }

    return `
      background-image: url(/assets/images/info-tooltip-normal.png);
    `;
  }}

  @media (max-width: 768px) {
    width: 16px;
    height: 16px;
  }
`;

export const TransactionStatusText = styled.div`
  color: #475061;
  font-size: 14px;
  font-family: Nunito, sans-serif;
  line-height: 20px;

  span.regular {
    font-weight: 400;
  }

  span.bold {
    font-weight: 700;
  }
`;

// ===================================
// CONTENT INSIDE
// ===================================
export const ContentInside = styled.div`
  padding: 0 16px 32px 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// ===================================
// DATE INFO
// ===================================
export const DateInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 50px;

  @media (max-width: 768px) {
    align-items: flex-start;
    gap: 2px;
    margin-top: 24px;
  }

  span.regular {
    color: black;
    font-size: 16px;
    font-family: Nunito, sans-serif;
    font-weight: 400;
    line-height: 24px;
  }

  span.bold {
    color: black;
    font-size: 16px;
    font-family: Nunito, sans-serif;
    font-weight: 700;
    line-height: 24px;
  }
`;

// ===================================
// PAYMENT OPTION CARD
// ===================================
export const PaymentOption = styled.div`
  padding: 16px 12px;
  background: #f5f6f8;
  border-radius: 8px;
  border: ${(props) =>
    props.selected ? "1px solid #0BBEF0" : "1px solid transparent"};
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => (props.disabled ? "transparent" : "#0bbef0")};
  }
`;

export const OptionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  position: relative;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const OptionLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;

export const OptionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 0;

  @media (max-width: 768px) {
    order: 2;
  }

  h3 {
    color: #00084b;
    font-size: 24px;
    font-family: Nunito, sans-serif;
    font-weight: 700;
    line-height: 32px;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const OptionLabel = styled.div`
  color: #00084b;
  font-size: 14px;
  font-family: Nunito, sans-serif;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;

  @media (max-width: 768px) {
    justify-content: flex-start;
    order: 4;
  }
`;

export const OptionDescription = styled.div`
  color: #31302f;
  font-size: 14px;
  font-family: Nunito, sans-serif;
  font-weight: 400;
  line-height: 20px;
  flex: 1 1 0;

  @media (max-width: 768px) {
    font-size: 14px;
    order: 3;
  }
`;

export const OptionRight = styled.div`
  display: flex;
  align-self: ${(props) => props.verticalAlign || "center"};
  position: relative;
  ${(props) => props.marginTop && `margin-top: ${props.marginTop};`}

  @media (max-width: 768px) {
    align-self: ${(props) => props.mobileVerticalAlign || "flex-start"};
    margin-top: ${(props) => props.mobileMarginTop || "10px"};
  }
`;

export const RadioButton = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #0bbef0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
  }

  ${(props) =>
    props.checked &&
    `
    &::after {
      content: '';
      width: 10px;
      height: 10px;
      background-image: url(/assets/images/arrow.png);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  `}
`;

// ===================================
// AMOUNT DISPLAY
// ===================================
export const AmountRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 16px;
  margin-top: 8px;

  &:first-child {
    margin-top: 0;
  }

  @media (max-width: 768px) {
    display: contents;
  }
`;

export const AmountValue = styled.div`
  color: #00084b;
  font-size: 20px;
  font-family: Nunito, sans-serif;
  font-weight: 700;
  line-height: 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 24px;
    order: 5;
    justify-content: flex-start;
  }
`;

// ===================================
// DOWNLOAD BUTTON
// ===================================
export const DownloadRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  gap: 16px;
  margin-top: 8px;

  @media (max-width: 768px) {
    display: contents;
  }
`;

export const DownloadButton = styled.button`
  min-width: 136px;
  padding: 4px 8px;
  background: #0bbef0;
  border-radius: 48px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
  transition: background 0.2s ease;

  @media (max-width: 768px) {
    max-width: 136px;
    order: 7;
  }

  &:hover {
    background: #0aa3d1;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  span {
    color: white;
    font-size: 16px;
    font-family: Nunito, sans-serif;
    font-weight: 700;
    line-height: 24px;
  }
`;

export const DownloadIcon = styled.div`
  width: 20px;
  height: 20px;
  background-image: url(/assets/images/excel.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export const DownloadDescription = styled.div`
  color: #31302f;
  font-size: 14px;
  font-family: Nunito, sans-serif;
  font-weight: 400;
  line-height: 20px;
  flex: 1 1 0;

  @media (max-width: 768px) {
    font-size: 14px;
    order: 6;
  }
`;

// ===================================
// INPUT FIELD (para "Otro monto")
// ===================================
export const InputField = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  position: relative;

  @media (max-width: 768px) {
    width: auto;
    border-radius: 4px;
    padding: 8px 12px;
    background: #fff;
    order: 5;
    justify-self: flex-start;
  }

  /* Currency icon placed inside the input area */
  span.currency {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
    font-family: Nunito, sans-serif;
    font-weight: 700;
    line-height: 24px;
    color: ${(props) => (props.showCurrency ? "#00084b" : "transparent")};
    pointer-events: none;

    @media (max-width: 768px) {
      position: relative;
      left: 0;
      top: 0;
      transform: none;
      color: ${(props) => (props.showCurrency ? "#00084b" : "transparent")};
    }
  }

  input {
    border: none;
    outline: none;
    background: #fff;
    width: 188px;
    height: 40px;
    font-size: 20px;
    font-family: Nunito, sans-serif;
    font-weight: 700;
    line-height: 24px;
    color: #00084b;
    text-align: right;
    padding: 0;
    /* add left padding when currency is visible */
    padding-left: ${(props) => (props.showCurrency ? "24px" : "0")};

    @media (max-width: 768px) {
      padding-left: 8px;
    }

    &::placeholder {
      color: ${(props) => (props.showCurrency ? "#00084b" : "#ccc")};
    }

    /* Quitar flechas del input number */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type="number"] {
      -moz-appearance: textfield;
      appearance: textfield;
    }
  }
`;

// ===================================
// PAY BUTTON
// ===================================
export const PayButton = styled.button`
  width: 280px;
  padding: 8px 48px;
  border-radius: 48px;
  border: 2px solid #0bbef0;
  background: transparent;
  color: #0bbef0;
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: auto auto 0 auto;
  transition: all 0.2s ease;

  ${(props) =>
    !props.disabled &&
    `
    &:hover {
      background: #0BBEF0;
      color: white;

      span {
        color: white;
      }

      svg path {
        stroke: white;
      }
    }
  `}

  span {
    font-size: 18px;
    font-family: Nunito, sans-serif;
    font-weight: 700;
    line-height: 24px;
    color: #0bbef0;
  }
`;

export const ChevronIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg path {
    stroke: #0bbef0;
    transition: stroke 0.2s ease;
  }
`;

// ===================================
// INFO TOOLTIP ICON
// ===================================
export const InfoTooltip = styled.div`
  width: 20px;
  height: 20px;
  background-image: url(/assets/images/info-tooltip-oscuro.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: help;
  position: relative;
`;

// ===================================
// EMPTY STATE - Sin pagos pendientes
// ===================================
export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 71px;
  padding: 48px 48px 150px 50px;
`;

export const EmptyStateTitle = styled.div`
  color: #475061;
  font-size: 24px;
  font-family: Nunito, sans-serif;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const EmptyStateMessage = styled.div`
  color: #475061;
  font-size: 20px;
  font-family: Nunito, sans-serif;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  max-width: 400px;

  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 24px;
    width: 300px;
    height: 48px;
  }
`;

// ===================================
// PARTIAL PAYMENT STATE - Pago parcial procesándose
// ===================================
export const PartialPaymentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 48px;
  padding: 48px 48px 150px 50px;
`;

export const PartialPaymentTitle = styled.div`
  color: #475061;
  font-size: 20px;
  font-family: Nunito, sans-serif;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PartialPaymentMessage = styled.div`
  color: #475061;
  font-size: 20px;
  font-family: Nunito, sans-serif;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  word-wrap: break-word;

  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 24px;
    width: ${(props) => (props.numberTwo ? "260px" : "auto")};
  }
`;

// ===================================
// TIMELINE - Días restantes para pago
// ===================================
export const TimelineContainer = styled.div`
  width: 100%;
  padding: 0 24px;
  position: relative;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 767px) {
    height: 120px;
    padding: 0 12px;
  }
`;

export const TimelineTrack = styled.div`
  width: ${(props) => props.width || "100%"};
  height: 2px;
  position: absolute;
  left: ${(props) => props.left || "0"};
  top: 32px;
  background: ${(props) => {
    if (props.isNearDue) {
      return "#FF317B";
    }

    if (props.isProgress) {
      return "#045F75";
    }

    return "#C7CDCD";
  }};
`;

export const TimelineMarker = styled.div`
  width: 15px;
  height: 15px;
  position: absolute;
  left: ${(props) => props.position || "50%"};
  top: 25px;
  background: white;
  border-radius: 50px;
  border: 2px ${(props) => (props.isOverdue ? "#FF317B" : "#045F75")} solid;
  transform: translateX(-50%);
`;

export const TimelineDayLabel = styled.div`
  position: absolute;
  left: ${(props) => props.position};
  top: ${(props) => props.top || "8px"};
  color: ${(props) => (props.isHighlighted ? "#FF317B" : "#045F75")};
  font-size: 14px;
  font-family: ${(props) => (props.isPipe ? "Roboto" : "Nunito")}, sans-serif;
  font-weight: ${(props) => (props.isPipe ? "300" : "400")};
  line-height: 20px;
  letter-spacing: ${(props) => (props.isPipe ? "2.50px" : "0")};
  text-align: center;
  transform: translateX(-50%);

  @media (max-width: 767px) {
    font-size: 11px;
    line-height: 22px;
    left: ${(props) => `calc(${props.position} - 0.1%)`};
  }
`;

export const TimelineMessage = styled.div`
  position: absolute;
  left: ${(props) =>
    props.align === "left" ? "24px" : props.align === "right" ? "auto" : "50%"};
  right: ${(props) => (props.align === "right" ? "24px" : "auto")};
  transform: ${(props) =>
    props.align === "left" || props.align === "right"
      ? "none"
      : "translateX(-50%)"};
  top: 54px;
  padding: 8px 17px;
  background: ${(props) => (props.isOverdue ? "#FFE0EB" : "#C7F2FC")};
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 300px;
  text-align: center;

  @media (max-width: 767px) {
    padding: 6px 12px;
    max-width: 220px;
    margin-bottom: 50px;
  }
`;

export const TimelineMessageText = styled.div`
  color: ${(props) => (props.isOverdue ? "#475061" : "#045F75")};
  font-size: 14px;
  text-align: center;
  font-family: Nunito, sans-serif;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
  white-space: pre-line;

  span.highlight {
    color: ${(props) => (props.isOverdue ? "#FF317B" : "#045F75")};
    font-weight: 700;
  }

  @media (max-width: 767px) {
    font-size: 12px;
    line-height: 14px;
  }
`;

// ===================================
// ALERT/VALIDATION COMPONENTS - HU AC01.1, AC01.2
// ===================================

/**
 * Contenedor de alerta de validación (naranja)
 * Posicionado debajo del input, alineado a la derecha
 */
export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
  width: 100%;

  @media (max-width: 768px) {
    width: 228px;
    justify-content: right;
    order: 5;
  }
`;

/**
 * Texto de alerta (naranja) - HU diseño Figma
 */
export const AlertText = styled.span`
  color: #ff7d00;
  font-family: Nunito, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;

/**
 * Icono de información para alertas (pequeño círculo con i)
 */
export const AlertInfoIcon = styled.div`
  width: 16px;
  height: 16px;
  background-color: #475061;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  font-weight: 700;
  font-family: Nunito, sans-serif;
  cursor: help;
  position: relative;

  &::after {
    content: "i";
  }
`;

export const InputFieldWithError = styled(InputField)`
  ${(props) =>
    props.isError &&
    `
    outline: 1px #FF7D00 solid;
    outline-offset: -1px;
    border-color: transparent;
    padding-left: 4px;
    padding-right: 4px;
    background: white;
    
    @media (max-width: 768px) {
      outline: none;
      padding: 8px 12px;
      order: 4;
    }
    
    span.currency {
      color: #FF7D00;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
    }
    
    input {
      color: #FF7D00;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      
      &::placeholder {
        color: #FF7D00;
        opacity: 0.5;
      }
    }
  `}
`;
